import '../vendor/lifeworld-shared-base/src/lifeworld-base.css';
import './styles/life-world.css';
import { mountLifeWorld } from './world/app.js';

mountLifeWorld();
